var map = {
	"../auth/auth.module": [
		"../../../../../src/app/auth/auth.module.ts",
		"auth.module"
	],
	"../charts/charts.module": [
		"../../../../../src/app/charts/charts.module.ts",
		"charts.module",
		"common"
	],
	"../chats/chat.module": [
		"../../../../../src/app/chats/chat.module.ts",
		"common",
		"chat.module"
	],
	"../dashboard-accounts/dashboard-accounts.module": [
		"../../../../../src/app/dashboard-accounts/dashboard-accounts.module.ts",
		"dashboard-accounts.module"
	],
	"../dashboard-crm/dashboard-crm.module": [
		"../../../../../src/app/dashboard-crm/dashboard-crm.module.ts",
		"dashboard-crm.module",
		"common"
	],
	"../editor/editor.module": [
		"../../../../../src/app/editor/editor.module.ts",
		"common",
		"editor.module"
	],
	"../forms/forms.module": [
		"../../../../../src/app/forms/forms.module.ts",
		"forms.module"
	],
	"../guarded-routes/guarded-routes.module": [
		"../../../../../src/app/guarded-routes/guarded-routes.module.ts",
		"guarded-routes.module"
	],
	"../mail/mail.module": [
		"../../../../../src/app/mail/mail.module.ts",
		"common",
		"mail.module"
	],
	"../maps/maps.module": [
		"../../../../../src/app/maps/maps.module.ts",
		"common",
		"maps.module"
	],
	"../material-widgets/material-widgets.module": [
		"../../../../../src/app/material-widgets/material-widgets.module.ts",
		"common",
		"material-widgets.module"
	],
	"../pages/login/login.module": [
		"../../../../../src/app/pages/login/login.module.ts",
		"login.module"
	],
	"../pages/pages.module": [
		"../../../../../src/app/pages/pages.module.ts",
		"pages.module"
	],
	"../register/register.module": [
		"../../../../../src/app/register/register.module.ts",
		"register.module"
	],
	"../scrumboard/scrumboard.module": [
		"../../../../../src/app/scrumboard/scrumboard.module.ts",
		"scrumboard.module"
	],
	"../tables/tables.module": [
		"../../../../../src/app/tables/tables.module.ts",
		"common",
		"tables.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// E:/sree/New folder (3)/cdk-material-v2/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main